export default class MB_Search {

    constructor(mb){
        this.mb = mb;
        this.mb.hooks.after_search = [];
        this.input_init();
    }

    input_init(){
        
        this.container = null;

        if( this.mb.filters ) {
            this.container = this.mb.filters.container.querySelector('.mb_search');
        }
        
        if( !this.container ) {
            this.container = document.querySelector('.mb_search ');
        }

        if( !this.container ) return;
        
        this.input = this.container.querySelector('input');
        this.search_string = '';

        let timer = null;
        this.input.addEventListener('keydown',e=>{
            clearTimeout(timer);
            if( e.key == 'Enter' ) {
                this.search(this.input.value);
                return;
            }
            timer = setTimeout(()=>this.search(this.input.value), 500);
        }); 
    }

    search(search_string){
        if( search_string === this.search_string ) return;
        this.search_string = search_string;
        this.mb.filter();
        // this.isotope_search(search_string);
        // this.mb.show_minimum_items();
        // this.mb.toggle_no_results();
        this.mb.hooks.after_search.forEach(action=>action());
    }
    
    // isotope_search(search_string){
    //     const regex = new RegExp( search_string, 'gi' );
    //     this.mb.isotope.arrange({ filter: function(i,el){
    //         return regex ? el.textContent.match( regex ) : true;
    //     }})
    // }
}